<template>
  <q-page class="container" padding>
    <div class="row col-12 text-brand-5">
      <q-icon
        style="margin-top: 2px; cursor: pointer"
        name="arrow_back_ios"
        size="26px"
        @click="$router.push({ name: 'criarCliente' })"
      />
      <p class="text-h6 self-end text-brand-5 text-weight-bold">
        Detalhes do Cliente
      </p>
    </div>

    <q-form ref="myForm">
      <q-card class="q-mt-md text-brand-5">
        <div class="row q-pt-sm justify-center col-12">
          <p class="text-h6 self-end text-brand-5 text-weight-bold">
            Dados e estado do cliente
          </p>
        </div>
        <q-card-section>
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">Cliente ID</p>
              <p class="teste">
                {{ cliente.clienteId }}
              </p>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">Status</p>
              <p class="teste" v-show="cliente.ativo == true">Ativo</p>
              <p class="teste" v-show="cliente.ativo != true">Não ativo</p>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-2">
              <span class="text-brand-5 text-weight-bold"
                >Sincronizar Permissões</span
              >
              <p></p>
              <q-btn
                class="q-ml-xl"
                color="positive"
                icon="sync"
                round
                size="md"
                @click.prevent="sincronizar()"
              />
            </div>

            <div class="col-md-2 col-sm-12 col-xs-2">
              <span class="text-brand-5 text-weight-bold">Ativar Cliente</span>
              <p></p>
              <q-btn
                :disable="cliente.ativo"
                class="q-ml-md"
                color="positive"
                icon="task_alt"
                round
                size="md"
                @click.prevent="ativarCliente()"
              />
            </div>

            <div class="col-md-2 col-sm-12 col-xs-2">
              <span class="text-brand-5 text-weight-bold"
                >Cliente em manutenção</span
              >
              <p v-if="cliente.manutencao.ativa" class="text-negative">Sim</p>
              <p v-else class="text-positive">Não</p>
              <q-btn
                class="q-ml-md"
                color="positive"
                icon="engineering"
                round
                size="md"
                @click="manutencaoDialog = true"
              />
            </div>

            <div
              class="col-md-12 col-sm-12 col-xs-12"
              v-if="!bancoDados.bancoDadosId"
            >
              <q-select
                dense
                outlined
                v-model="bancoSelecionado"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="listaBancos"
                option-label="bancoDadosId"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey"
                      >Nenhum Resultado</q-item-section
                    >
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>
        </q-card-section>

        <div
          class="col-md-1 col-sm-12 col-xs-12"
          v-if="!bancoDados.bancoDadosId"
        >
          <q-btn
            dense
            flat
            class="q-mt-sm full-width"
            color="primary"
            label="Configurar"
            @click="configurar"
          />
        </div>
      </q-card>

      <q-card class="q-mt-md text-brand-5" v-if="bancoDados.bancoDadosId">
        <div class="row q-pt-sm justify-center col-12">
          <p class="text-h6 self-end text-brand-5 text-weight-bold">
            Informações do banco
          </p>
        </div>
        <q-card-section>
          <div class="row col-12 q-col-gutter-sm">
            <div class="column col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">Banco nome</p>
              <p>{{ bancoDados.bancoDadosId }}</p>
            </div>

            <div class="column col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">Schema</p>
              <p>{{ bancoDados.schema }}</p>
            </div>
          </div>
        </q-card-section>
      </q-card>

      <q-card class="q-mt-md text-brand-5" v-show="!autt">
        <div class="row q-pt-sm justify-center col-12">
          <p class="text-h6 self-end text-brand-5 text-weight-bold">
            Dados de autenticação
          </p>
        </div>
        <q-card-section>
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-2 col-sm-12 col-xs-12">
              <q-select
                v-if="!autt"
                dense
                outlined
                v-model="autenticacao.autenticacaoProvedorId"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="listaAutenticacao"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey"
                      >Nenhum Resultado</q-item-section
                    >
                  </q-item>
                </template>
              </q-select>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <q-input
                v-show="!autt"
                dense
                outlined
                v-model="autenticacao.publicKey"
                label="publicKey"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <q-input
                v-show="!autt"
                dense
                outlined
                v-model="autenticacao.keyAlg"
                label="KeyAlg"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <q-input
                v-show="!autt"
                dense
                outlined
                v-model="autenticacao.realm"
                label="realm"
              >
                <template v-slot:prepend>
                  <q-icon name="person" />
                </template>
              </q-input>
            </div>
          </div>
        </q-card-section>

        <div class="col-md-1 col-sm-12 col-xs-12">
          <q-btn
            dense
            flat
            class="q-mt-sm full-width"
            color="primary"
            label="Configurar Autenticação"
            @click="autenticarCliente"
          />
        </div>
      </q-card>

      <q-card class="q-mt-md text-brand-5" v-show="autt == true">
        <div class="row q-pt-sm justify-center col-12">
          <p class="text-h6 self-end text-brand-5 text-weight-bold">
            Dados de autenticação
          </p>
        </div>
        <q-card-section class="text-brand-5">
          <div class="row col-12 q-col-gutter-sm">
            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">ProvedorId</p>
              <p>{{ autenticacao.autenticacaoProvedorId }}</p>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">publicKey</p>
              {{ autenticacao.publicKey.substr(0, 15) }}
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">KeyAlg</p>
              <p class="teste" v-if="autenticacao.keyAlg">
                {{ autenticacao.keyAlg }}
              </p>
            </div>

            <div class="col-md-2 col-sm-12 col-xs-12">
              <p class="text-bold">Realm</p>
              <p>{{ autenticacao.realm }}</p>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-form>

    <div class="row justify-around q-mt-md text-brand-5">
      <div class="row q-pt-sm justify-center col-12">
        <p class="text-h6 self-end">Gerenciar Módulos</p>
      </div>

      <tabela-modulos-ativos
        :modulosAtivos="modulosAtivos"
        :clienteId="clienteId"
        @atualizarTabelas="atualizar"
      />

      <tabela-modulos-desativados
        :modulosDesativos="modulosDesativos"
        :clienteId="clienteId"
        @atualizarTabelas="atualizar"
      />
    </div>

    <q-dialog v-model="manutencaoDialog" backdrop-filter="brightness(60%)">
      <q-card>
        <q-card-section class="row items-center q-pb-none text-h6">
          Alterar manutenção
        </q-card-section>

        <q-card-section>
          <div class="q-pa-md">
            <q-form class="q-gutter-y-md">
              <q-toggle label="Ativa" v-model="cliente.manutencao.ativa" />
              <q-input
                outlined
                label="Motivo"
                v-model="cliente.manutencao.motivo"
              />
              <q-input
                outlined
                label="Previsão"
                v-model="cliente.manutencao.previsao"
              />
            </q-form>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Fechar" color="primary" v-close-popup />
          <q-btn
            flat
            label="Alterar"
            color="positive"
            v-close-popup
            @click="alterarManutencao"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import TabelaModulosAtivos from "../components/TabelaModulosAtivos.vue";
import TabelaModulosDesativados from "../components/TabelaModulosDesativados.vue";

export default {
  components: {
    TabelaModulosAtivos,
    TabelaModulosDesativados,
  },
  name: "DetalheCliente",
  setup() {
    const $route = useRoute();

    const manutencaoDialog = ref(false);
    const myForm = ref(null);
    const store = useStore();
    const modulosAtivos = ref([]);
    const modulosDesativos = ref([]);
    const clienteId = $route.params.clienteId;
    const $q = useQuasar();
    const tab = ref("ativo");
    const cliente = ref({
      clienteId: "",
      ativo: "",
      manutencao: {
        ativa: false,
      },
    });
    console.log(cliente.value);
    const listaBancos = ref([]);
    const listaAutenticacao = ref([]);
    const bancoSelecionado = ref(null);
    let autt = ref(false);

    const autenticacao = ref({
      autenticacaoProvedorId: "",
      publicKey: "",
      keyAlg: "",
      realm: "",
    });

    const bancoDados = ref({
      bancoDadosId: "",
      host: "",
      port: "",
      schema: "",
      user: "",
    });

    const columns = [
      {
        name: "clienteId",
        label: "ID",
        field: "clienteId",
        align: "left",
        sortable: true,
      },
      { name: "ativo", label: "ATIVO", field: "ativo", align: "left" },
    ];

    let consultar = async () => {
      try {
        let resposta = await store.dispatch("office/detalharCliente", {
          clienteId: clienteId,
        });

        autenticacao.value.autenticacaoProvedorId =
          resposta.alth.autenticacaoProvedorId;

        autenticacao.value.publicKey = resposta.alth.publicKey;
        autenticacao.value.keyAlg = resposta.alth.keyAlg;
        autenticacao.value.realm = resposta.alth.realm;
        if (resposta.alth.length != 0) {
          autt.value = true;
        }
        listarBancos();
        listarAutenticacao();
        cliente.value = resposta.cliente;
        bancoDados.value = resposta.bancoDados;
      } catch (error) {
        console.error(error);
      }
    };

    let listarBancos = async () => {
      try {
        let resposta = await store.dispatch("office/listarBanco");
        listaBancos.value = resposta.listaBancos;
      } catch (error) {
        console.error(error);
      }
    };

    const configurar = async () => {
      try {
        await store.dispatch("office/configurarCliente", {
          clienteId: cliente.value.clienteId,
          bancoDadosId: bancoSelecionado.value.bancoDadosId,
        });

        $q.notify({
          message: "Configuracao Cadastrada!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        consultar();
        autt.value = false;
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.erros) {
            $q.notify({
              message: e.response.data.erros[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    let listarAutenticacao = async () => {
      try {
        let resposta = await store.dispatch("office/listarAutenticacao");
        resposta.listaAutenticacao.forEach((e) => {
          listaAutenticacao.value.push(e.autenticacaoProvedorId);
        });
      } catch (error) {
        console.error(error);
      }
    };

    const autenticarCliente = async () => {
      try {
        await store.dispatch("office/Autenticar", {
          autenticacaoProvedorId: autenticacao.value.autenticacaoProvedorId,
          publicKey: autenticacao.value.publicKey,
          keyAlg: autenticacao.value.keyAlg,
          realm: autenticacao.value.realm,
          clienteId: clienteId,
        });

        $q.notify({
          message: "Configuracao Cadastrada!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        autt.value = true;
        consultar();
      } catch (error) {
        console.error(error);
        $q.notify({
          message: "Erro a o configurar autenticação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        autt.value = false;
        consultar();
      }
    };

    const getModulosAtivos = async () => {
      try {
        let resposta = await store.dispatch(
          "office/listarModuloClienteAtivos",
          {
            clienteId,
          }
        );
        modulosAtivos.value = resposta.data.resultado.dados;
      } catch (error) {
        console.error(error);
      }
    };

    const getModulosDesativos = async () => {
      try {
        let resposta = await store.dispatch(
          "office/listarModuloClienteDesativos",
          {
            clienteId,
          }
        );
        modulosDesativos.value = resposta.data.resultado.dados;
      } catch (error) {
        console.error(error);
      }
    };
    const sincronizar = async () => {
      try {
        await store.dispatch("office/sincronizarPermissoes", {
          clienteId,
        });

        $q.notify({
          type: "positive",
          message: "Sincronizado com Sucesso",
          position: "top",
        });
      } catch (e) {
        $q.notify({
          type: "negative",
          message: e.response.data.erros.Mensagem,
          position: "top",
        });
      }
    };
    const ativarCliente = async () => {
      try {
        await store.dispatch("office/ativarCliente", {
          clienteId: clienteId,
        });
        $q.notify({
          message: `O cliente ${clienteId} foi ativado com sucesso`,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        consultar();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao ativar cliente",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const alterarManutencao = async () => {
      try {
        await store.dispatch("office/alterarManutencao", {
          clienteId: clienteId,
          manutencao: cliente.value.manutencao,
        });
        $q.notify({
          message: `Manutencao ${clienteId} foi alterada com sucesso`,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao alterar manutenção do cliente",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizar = async () => {
      getModulosAtivos();
      getModulosDesativos();
    };

    onMounted(consultar);
    onMounted(getModulosAtivos);
    onMounted(getModulosDesativos);

    return {
      modulosDesativos,
      atualizar,
      modulosAtivos,
      getModulosDesativos,
      getModulosAtivos,
      cliente,
      bancoDados,
      listaBancos,
      listarBancos,
      myForm,
      options: ["SIM", "NÃO"],
      columns,
      filter: ref(""),
      consultar,
      clienteId,
      bancoSelecionado,
      configurar,
      autenticacao,
      listarAutenticacao,
      listaAutenticacao,
      autenticarCliente,
      autt,
      tab,
      sincronizar,
      ativarCliente,
      manutencaoDialog,
      alterarManutencao,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
